import React, { useEffect } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useStore from "../store";
import { supabase } from "../supabase";

const sendMessage = async (msg) => {
  const telegramUrl = `https://api.telegram.org/bot6070974807:AAHuUAyzLAgL7UBGWnaHXcYGjHil6atLvo0/sendMessage`;

  const ids = [166061091, 1860086398];

  for (let id of ids) {
    const response = await fetch(telegramUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        chat_id: id,
        text: msg,
      }),
    });

    const data = await response.json();
    console.log(data);

    if (!response.ok || !data?.ok) {
      throw new Error(
        `Telegram send failed for chat ${id}: ${data?.description || response.status}`
      );
    }
  }
};

function ThankYou() {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const cart = useStore((state) => state.cart);
  const setCart = useStore((state) => state.setCart);
  const user = useStore((state) => state.user);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const checkoutSignal =
      params.checkout ||
      searchParams.get("checkout") ||
      searchParams.get("session_id") ||
      searchParams.get("success");
    const storedCart = sessionStorage.getItem("kumo-checkout-cart");
    const checkoutCart = cart.length > 0 ? cart : storedCart ? JSON.parse(storedCart) : [];

    if (!checkoutSignal || checkoutCart.length === 0) {
      return;
    }

    const checkoutKey = `kumo-checkout-processed:${checkoutSignal}`;
    const checkoutInFlightKey = `kumo-checkout-processing:${checkoutSignal}`;

    if (
      sessionStorage.getItem(checkoutKey) === "true" ||
      sessionStorage.getItem(checkoutInFlightKey) === "true"
    ) {
      return;
    }

    sessionStorage.setItem(checkoutInFlightKey, "true");

    const saveOrderAndNotify = async () => {
      const pedido = checkoutCart.map((producto) => ({
        nombre: producto.nombre,
        precio: producto.precio,
        talla: producto.talla ? producto.talla : "",
        color: producto.color ? producto.color : "",
      }));

      console.log("Pedido enviado desde ThankYou", pedido);

      const { error } = await supabase.from("Pedidos").insert(pedido);

      if (error) {
        console.error("Error al guardar pedido:", error);
        sessionStorage.removeItem(checkoutInFlightKey);
        return;
      }

      const msg = `NUEVO PEDIDO${user?.name ? ` de ${user.name}` : ""}: ${checkoutCart
        .map(
          (producto) =>
            `\n${producto.nombre} talla ${producto.talla ? producto.talla : ""} color ${
              producto.color ? producto.color : ""
            }`
        )
        .join(", ")}`;

      try {
        await sendMessage(msg);
        sessionStorage.setItem(checkoutKey, "true");
      } catch (telegramError) {
        console.error("Error enviando Telegram:", telegramError);
        sessionStorage.removeItem(checkoutInFlightKey);
        return;
      }

      setCart([]);
      sessionStorage.removeItem(checkoutInFlightKey);
      sessionStorage.removeItem("kumo-checkout-cart");
      sessionStorage.removeItem("kumo-checkout-started");
    };

    saveOrderAndNotify();
  }, [params.checkout, location.search, cart, setCart, user]);

  return (
    <div>
      <div
        className="w-full h-screen bg-contain bg-bottom bg-no-repeat bg-black text-white flex flex-col justify-start items-center pt-20 text-3xl font-bold px-20"
        style={{
          backgroundImage: `url("https://res.cloudinary.com/dt9ivv2ug/image/upload/v1694808532/thankyou_1_ixvp7x.png")`,
        }}
      >
        <h1 className="text-5xl font-bold text-center text-white">
          ¡¡Gracias por tu compra!!
        </h1>
        <div className="absolute top-10 right-10 h-6 w-6 rounded-full flex justify-center items-center">
          <AiFillCloseCircle size={25} onClick={() => navigate("/")} />
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
